import { apiClient } from '../client'
import type { ApiSuccessResponse } from '../../types/api'
import type { Permission, Role, RolePermissionsPayload } from '../../types/role'

export const roleService = {
  async list() {
    const { data } = await apiClient.get<ApiSuccessResponse<Role[]>>('/roles')
    return data
  },

  async show(id: string) {
    const { data } = await apiClient.get<ApiSuccessResponse<Role>>(`/roles/${id}`)
    return data
  },

  async updatePermissions(id: string, payload: RolePermissionsPayload) {
    const { data } = await apiClient.put<ApiSuccessResponse<Role>>(`/roles/${id}`, payload)
    return data
  },
}

export const permissionService = {
  async list() {
    const { data } = await apiClient.get<ApiSuccessResponse<Permission[]>>('/permissions')
    return data
  },
}
